import { style, media } from 'typestyle'
import { important } from 'csx'
export const pr12smi = style(media({ maxWidth: 576 }, { paddingRight: important('12px') }))
